// Pageinvoice Component
/* eslint indent: 0 */

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import List from '../../../../components/List/List.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import InvoiceItem from '../../invoice/invoice_item/invoice_item.jsx'
import DialogSetting from '../../dialog/dialog_setting/dialog_setting.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import DialogInvoiceAdd from '../../dialog/dialog_invoice_add/dialog_invoice_add.jsx'
import DialogCopyInvoice from '../../dialog/dialog_copyinvoice/dialog_copyinvoice.jsx'
import ReportPriceCell from '../../../report/report/report_pricecell/report_pricecell.jsx'
import DialogInvoiceCreditActual from '../../dialog/dialog_invoicecreditactual/dialog_invoicecreditactual.jsx'
import DialogMarkInvoice from '../../../invoice/dialog/dialog_markinvoice/dialog_markinvoice.jsx'
import PopupCompanyProfileData from '../../../common/popup/popup_companyprofile_data/popup_companyprofile_data.jsx'
import DialogEmailResend from '../../../common/dialog/dialog_email_resend/dialog_email_resend.jsx'
import DialogInvoiceExport from '../../dialog/dialog_invoice_export/dialog_invoice_export.jsx'
import Acl from '../../../lib/acl.jsx'
import InvoiceMailUtil from '../../../lib/invoicemailutil.jsx'
import EmailUtil from '../../../lib/emailutil.js'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import Util from '../../../lib/util.jsx'
import { InvoicesIcon } from '../../../common/layout/menu_icons/invoices.jsx'

class PageInvoice extends PageBase {
  constructor (props) {
    super(props, 'invoices', 'invoices', 'invoices')

    this.state = {
      isLoading: true,
      dataDate: null,
      pageNo: 1,
      showDataAlert: true,
      profilerId: null,
      bShowDialog: false
    }

    this.data = {
      invoices: [],
      stat: null,
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      pageNo: 1,
      pageState: {
        sort: 'title',
        sortAsc: true,
        type: 'grid',
        filter: null
      },
      companyFields: [],
      activeInvoicePersons: [],
      activeInvoice: null
    }

    this._setFABButtonState(true, false)
    this.estimateApproveDate = ''
    this._references = {
      popupcompanyprofiledata: React.createRef(),
      dialogInvoiceAdd: React.createRef(),
      invoiceSettingDialog: React.createRef(),
      refdialogMail: React.createRef(),
      refDialogMarkInvoice: React.createRef(),
      refDialogCopyInvoice: React.createRef(),
      invoiceExportDialog: React.createRef(),
      dialogInvoiceCreditActual: React.createRef(),
      refHeaderInvoice: React.createRef(),
      refdialogMailSend: React.createRef()
    }

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()

    this._bUnMounted = false
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._getData(false)
    this._initEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
    this._bUnMounted = true

    this._releaseEvents()

    this._profiler = null
  }

  _handleDocumentKeyDown = evt => {
    if (
      this.ignoreAutoSearch ||
      (this._references.dialogInvoiceAdd.current &&
        this._references.dialogInvoiceAdd.current.isActive()) ||
      (this._references.refdialogMail.current &&
        this._references.refdialogMail.current.isActive()) ||
      (this._references.refDialogCopyInvoice.current &&
        this._references.refDialogCopyInvoice.current.isActive()) ||
      (this._references.dialogInvoiceCreditActual.current &&
        this._references.dialogInvoiceCreditActual.current.isActive())
    ) {
      return
    }

    const keyCode = evt.keyCode || 0
    let bSearch = true

    if (this._references.refHeaderInvoice.current) {
      const keyCode = evt.keyCode || 0

      if (
        keyCode === 13 ||
        keyCode === 9 ||
        keyCode === 27 ||
        keyCode === 17 ||
        keyCode === 224
      ) {
        bSearch = false
      } else if (evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
        bSearch = false
      }
    }

    if (keyCode === 27) {
      this._references.refHeaderInvoice.current.onEscKeyDown()
    } else if (
      bSearch &&
      this._references.refHeaderInvoice.current &&
      this._references.refHeaderInvoice.current.canShowSearch() &&
      !this.state.bShowDialog
    ) {
      this._references.refHeaderInvoice.current.showSearch()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  renderContent () {
    const invoice = this.data.activeInvoice
    const suggestions =
      invoice && invoice.contact
        ? EmailUtil.getEmailSuggestions(invoice.contact)
        : []

    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderSettingsDialog()}
        {this._renderInvoiceDialog()}
        <DialogInvoiceAdd
          ref={this._references.dialogInvoiceAdd}
          getProjects={InvoiceUtil.getProjects}
          contactSearch={this._onSearchContact.bind(this)}
          onSubmit={this._onAddInvoice.bind(this)}
          getInvoiceInfo={InvoiceUtil.generateInvoice}
        />
        <DialogCopyInvoice
          ref={this._references.refDialogCopyInvoice}
          supplierSearch={this._onSearchContact.bind(this)}
          getProjects={InvoiceUtil.getProjects}
          onSubmit={this._onSubmitCopyInvoice.bind(this)}
        />
        <DialogInvoiceCreditActual
          ref={this._references.dialogInvoiceCreditActual}
          onSubmit={this._onSubmitCreditInvoice.bind(this)}
        />
        <DialogMarkInvoice
          ref={this._references.refDialogMarkInvoice}
          onSubmit={this._onSubmitMarkasPaid.bind(this)}
        />
        <PopupCompanyProfileData
          ref={this._references.popupcompanyprofiledata}
          companyData={this.data.companyFields}
          onClick={this._onClickAlert.bind(this)}
        />
        <DialogEmailResend
          ref={this._references.refdialogMail}
          onSubmit={this._onSubmitMail.bind(this)}
          showWithoutContext={false}
          downloadBaseUrl={`/invoice/preview/${app.getTeamId()}/${
            app.loggedInId
          }/`}
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
        />
        <DialogMail
          ref={this._references.refdialogMailSend}
          showMultiAttachments
          isLoading={this.state.isLoading}
          downloadUrl={this._getDownloadUrl(false)}
          mailSuggestions={suggestions}
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
          onSubmit={this._onSubmitMailDialog.bind(this)}
        />
      </div>
    )
  }

  getContentClassname () {
    return this.data.pageState.type === 'grid' ? 'alt' : null
  }

  /* Event handlers */
  _onClickAlert (_ev) {
    app.changePage('setting-companyprofile')
  }

  _getDownloadUrl (bIsDetails) {
    const { activeInvoice } = this.data

    if (activeInvoice) {
      const pdfFileName = activeInvoice
        ? Util.getPdfFileName(
            'invoice',
            activeInvoice.invoiceNo,
            activeInvoice.status
          )
        : ''
      const url = `/invoice/preview/${activeInvoice.teamId}/${app.loggedInId}/${activeInvoice.id}/${bIsDetails}/${pdfFileName}`
      return encodeURI(url)
    }

    return ''
  }

  _getData (bReload) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0

    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        invoice: {
          $limit: 20,
          $skip: skip,
          $client: {
            subObjects: {
              contact: ['company', 'image', 'imageUrl', 'contactPersons'],
              activities: ['items', 'objectId', 'type']
            }
          }
        }
      }
    }

    app
      .service('/api/page/invoice')
      .find(params)
      .then(result => {
        if (result) {
          this._onPageDataRecieved(result.pageData)

          if (result.stat) {
            this.data.stat = result.stat
          }
          if (result.companyFields) {
            this.data.companyFields = result.companyFields
          }
          if (result.invoiceResult) {
            this._processSorting(result.invoiceResult, params)
          }

          this._onDataReceived(null, profilerId)
        }
      })
      .catch(err => {
        this._onDataReceived(err, profilerId)
      })
  }

  /* _getData() {
          async.series([
              (done) => {
                  this._getPageData(done);
              },
              (done) => {
                  this._getDataStatInvoice(done);
              },
              (done) => {
                  this._getDataInvoice(done);
              },
              (done) => {
                  this._getDataProfile(done)
              }
          ], (err, _res) => {
              this._onDataReceived(err);
          });
    }

    _getDataProfile(callback) {
          CompanyUtil.getCompanyfields((fields) => {
              this.data.companyFields = fields;
              callback(null);
          });
    } */

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'title',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        type: pageState.type || 'grid',
        filter: this._getNormalizedFilter(pageState.filter)
      }
    }
  }

  /* _getDataStatInvoice(callback) {
          app.service('/api/page/invoice').get(null).then((result) => {
              this.data.stat = result ? result : null;
              callback(null);
          }).catch((err) => {
              app.debug('PageEstimate: _getDataStatInvoice err', err);
              callback(err);
          });
    }

    _getDataInvoice(callback) {
          app.debug('PageInvoice: _getDataInvoice [start]');

          const sort = this.data.pageState.sort;
          const sortAsc = this.data.pageState.sortAsc ? 1 : -1;
          const skip = (this.data.pageNo - 1) * 20;
          const params = {
              query: {
                  $limit: 20,
                  $skip: skip,
                  $sort: { },
                  $client: {
                      subObjects: {
                          'contact': ['company', 'image', 'imageUrl']
                      }
                  }
              }
          };

          params.query.$sort[sort] = sortAsc;

          // Process Filters
          const filter = this.data.pageState.filter;
          if (filter) {
              if (filter.project) {
                  params.query.projectId = filter.project.value;
              }

              if (filter.contact) {
                  params.query.contactId = filter.contact.value;
              }

              if (filter.status) {
                  const curDate = new Date();
                  const todayDate = new Date(curDate.getFullYear(), curDate.getMonth(), curDate.getDate());

                  if (filter.status === 'Overdue') {
                      params.query.dueDate = {
                          $lte: new Date(todayDate)
                      };
                      params.query.status = {
                          $in: ['Final']
                      };
                  } else if (filter.status === 'Final') {
                      params.query.dueDate = {
                          $gte: new Date(todayDate)
                      };
                      params.query.status = {
                          $in: ['Final']
                      };
                  } else {
                      params.query.status = filter.status;
                  }
              }

              if (filter.datefilter) {
                  params.query.invoiceDate = { };
                  if (filter.datefilter.value.from) {
                      params.query.invoiceDate['$gte'] = new Date(filter.datefilter.value.from);
                  }

                  if (filter.datefilter.value.to) {
                      params.query.invoiceDate['$lte'] = new Date(filter.datefilter.value.to);
                  }
              }
          }

          app.service('/api/invoice').find(params).then((result) => {
              this._processSorting(result, params);
              callback(null);
          }).catch((err) => {
              app.debug('PageInvoice: _getDataInvoice err', err);
              callback(err);
          });
    } */

  _processSorting (invoiceRes, params) {
    /* invoiceRes.data.map((invoice) => {
            invoice.title = invoice.contact ? invoice.contact.company : '';
            invoice.imageUrl = invoice.contact && invoice.contact.imageUrl ?
                invoice.contact.imageUrl : '';
        }); */

    /* if (invoiceRes.data && this.data.pageState.sort) {
       invoiceRes.data = _.sortBy(invoiceRes.data, this.data.pageState.sort);
       if (!this.data.pageState.sortAsc) {
         invoiceRes.data.reverse();
       }
    }
    } */

    this.data.invoices =
      this.data.pageNo > 1
        ? this.data.invoices.concat(invoiceRes.data)
        : invoiceRes.data
    this.data.total = invoiceRes.total
    this.data.countLoaded = params.query.$limit * this.data.pageNo
    this.data.canPaginate = !(this.data.countLoaded > this.data.total)
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageInvoice: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
    } else {
      if (
        this.data.companyFields.length > 0 &&
        this.state.showDataAlert &&
        this._references.popupcompanyprofiledata.current
      ) {
        this._references.popupcompanyprofiledata.current.show()
      }

      if (this.data.invoices && this.data.invoices.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      app.debug('PageInvoice: _onDataReceived [done]')
      this.setState({
        showDataAlert: false
      })
    }
    this.setState({
      isLoading: false,
      dataDate: new Date(),
      showDataAlert: false,
      profilerId: profilerId
    })
  }

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _onSearchProject (keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback)
  }

  _onAddInvoice (createObj, phaseId, onFinish) {
    const params = {
      query: {
        phaseId: phaseId,
        $client: {
          dateMethod: createObj.dateMethod
        }
      }
    }
    const invoiceObj = _.cloneDeep(createObj)
    delete invoiceObj.dateMethod
    const bApproved = invoiceObj.approveEstimate
    delete invoiceObj.approveEstimate
    this.estimateApproveDate = invoiceObj.approveDate
    delete invoiceObj.approveDate
    async.series(
      [
        done => {
          return InvoiceUtil.createInvoice(invoiceObj, params, (err, res) => {
            if (err) {
              app.debug('PageInvoice _onAddInvoice err', err)
              done(err)
            } else {
              if (this._references.dialogInvoiceAdd.current) {
                this._references.dialogInvoiceAdd.current.hide()
              }
              app.changePage('invoice-view', res.id)
              done(null)
            }
          })
        },
        done => {
          if (invoiceObj.estimateId && this.estimateApproveDate && bApproved) {
            const estObj = {
              referenceNumber: invoiceObj.referenceNo,
              reviewedOn: this.estimateApproveDate,
              status: 'Approved'
            }

            app
              .service('/api/estimate')
              .patch(invoiceObj.estimateId, estObj)
              .then(_estimateRes => {
                done(null)
              })
              .catch(estimateErr => {
                done(estimateErr)
              })
          } else {
            done(null)
          }
        }
      ],
      (asynErr, _asyncRes) => {
        if (onFinish) onFinish()
        if (asynErr) {
          app.debug('PageInvoice: _add invoice err', asynErr)
        }
      }
    )
  }

  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onExport () {
    if (this._references.invoiceExportDialog.current) {
      this._references.invoiceExportDialog.current.show()
    }
  }

  onAdd () {
    if (this._references.dialogInvoiceAdd.current) {
      this._references.dialogInvoiceAdd.current.show()
    }
  }

  _onGridItemClick (invoice, column) {
    if (
      column &&
      (column.identifier === 'title' || column.identifier === 'projectNumber')
    ) {
      app.changePage('projectview-budget', invoice.projectId)
    } else if (invoice && this._references.invoiceSettingDialog.current) {
      this._references.invoiceSettingDialog.current.hide()
      app.changePage('invoice-view', invoice.id)
    }
  }

  _onGridItemSettingClick (invoice) {
    if (invoice && this._references.invoiceSettingDialog.current) {
      this._references.invoiceSettingDialog.current.show(invoice)
    }
  }

  _onResendMail (invoice) {
    const params = { query: { bResend: true } }
    app
      .service('/api/invoice/mail')
      .get(invoice.id, params)
      .then(result => {
        if (result) {
          this.data.activeInvoicePersons = result.contactPersons
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(
              result,
              invoice.id,
              invoice
            )
          }
        }
      })
      .catch(err => {
        app.debug('PageInvoice: _showEmailDialog err', err)
      })
  }

  _onClickDownload (invoice) {
    const teamId = app.getTeamId()
    if (invoice) {
      const createObj = {
        invoiceId: invoice.id
      }

      app
        .service('/api/invoice/pdf')
        .create(createObj, {})
        .then(pdfRes => {
          app.redirect(
            encodeURI(`/invoice/download/${teamId}/${pdfRes.pdfName}`)
          )
        })
        .catch(pdfErr => {
          app.debug('PageInvoice: _onClickDownload', pdfErr)
        })
    }
  }

  _onEdit (invoice) {
    if (invoice) {
      app.changePage('invoice-view', invoice.id)
    }
  }

  _onPaid (invoice) {
    if (this._references.invoiceSettingDialog.current) {
      this._references.invoiceSettingDialog.current.hide()
    }

    const invoiceObj = {
      id: invoice.id,
      invoiceNo: invoice.invoiceNo,
      invoiceDate: invoice.invoiceDate,
      contactName: invoice.contact.company
    }
    if (this._references.refDialogMarkInvoice.current) {
      this._references.refDialogMarkInvoice.current.show(invoiceObj)
    }
  }

  _onOpenAttachment (invoice) {
    this._onClickDownload(invoice)
  }

  _onDelete (invoice) {
    if (!invoice.id) {
      return false
    }

    app
      .service('/api/invoice')
      .remove(invoice.id)
      .then(_deleteRes => {
        if (this._references.invoiceSettingDialog.current) {
          this._references.invoiceSettingDialog.current.hide()
        }
        this.data.pageNo = 1
        this._reloadData()
      })
      .catch(deleteErr => {
        app.debug('PageInvoice _onClickDeleteConfirm err', deleteErr)
      })
  }

  _onSubmitMarkasPaid (invoiceObj) {
    const invoiceId = invoiceObj.id
    delete invoiceObj.id
    app
      .service('/api/invoice')
      .patch(invoiceId, invoiceObj)
      .then(_paidRes => {
        if (this._references.refDialogMarkInvoice.current) {
          this._references.refDialogMarkInvoice.current.hide()
        }
        this._reloadData()
      })
      .catch(paidErr => {
        app.debug('PageInvoice: _onSubmitMarkasPaid err', paidErr)
      })
  }

  _onSubmitMailDialog (mailObj) {
    app.debug('PageInvoiceView: _onSubmitMail [Start]')

    if (this.data.activeInvoice) {
      EmailUtil.sendInvoiceMail(mailObj, this.data.activeInvoice, false, false)
        .then(_result => {
          if (this._references.refdialogMailSend.current) {
            this._references.refdialogMailSend.current.hide()

            if (this._references.invoiceSettingDialog.current) {
              this._references.invoiceSettingDialog.current.hide()
            }
          }

          this.data.activeInvoice = null
          this.setState({ bShowDialog: false })
        })
        .catch(err => {
          app.debug('PageInvoiceView: _onSubmitMail err', err)
          this.data.activeInvoice = null
        })
    }
  }

  _onSubmitMail (mailObj) {
    app.debug('PageInvoice: _onSubmitMail [Start]')
    this.setState({ isLoading: true })
    const emails = []
    const contactPersons = this.data.activeInvoicePersons
    if (contactPersons.length > 0) {
      contactPersons.map(contactPerson => {
        if (mailObj.toEmails && mailObj.toEmails.length > 0) {
          mailObj.toEmails.map(mail => {
            if (mail.text === contactPerson.key) {
              emails.push(contactPerson.email)
            }
          })
          _.remove(
            mailObj.toEmails,
            toEmail => toEmail.text === contactPerson.key
          )
        }
      })
    }

    mailObj.toEmails.map(mail => {
      emails.push(mail.text)
    })

    mailObj.toEmails = emails

    return InvoiceMailUtil.onSubmitMail(mailObj, res => {
      if (res) {
        this._updateInvoice(mailObj.id)
      } else {
        app.debug('PageInvoice : _onSubmitMail err')
      }
      this.setState({ isLoading: false })
    })
  }

  _updateInvoice (invoiceId) {
    const updateObj = { lastReminderDate: DateUtil.getUTCCurrentDate() }

    app
      .service('/api/invoice')
      .patch(invoiceId, updateObj)
      .then(_updateRes => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
      })
      .catch(updateErr => {
        app.debug('PageInvoice: _onUpdateInvoice err', updateErr)
      })
  }

  _onFilter (filter) {
    this.data.pageState.filter = this._getNormalizedFilter(filter)

    if (filter.contentType !== this.data.pageState.type) {
      this.data.pageState.type = filter.contentType
      this.forceUpdate()
      this._updatePageState(this.data.pageState)
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  _getNormalizedFilter = filter => {
    filter = filter || {}
    return {
      ...filter,
      status: filter.status || 'all',
      contact: filter.contact || null,
      datefilter: filter.datefilter || null,
      project: filter.project || null,
      keyword: filter.keyword || null
    }
  }

  _onCloseFilter () {
    this.data.pageState.filter = this._getNormalizedFilter()
    this._reloadData()
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._getData(false)
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _reloadData () {
    // this._updatePageState(this.data.pageState);
    this._getData(true)
  }

  _getListCloumns () {
    const projectSetting = app.projectSetting
    const columns = [
      {
        label: 'invoice.list.labelName',
        identifier: 'company',
        width: '14%',
        sort: false,
        filterType: 'autocomplete',
        type: 'link',
        field: 'contact'
      }
    ]

    if (projectSetting.useProjectNo) {
      columns.push({
        label: 'invoice.list.labelProjectNumber',
        identifier: 'projectNumber',
        width: '12%',
        sort: false,
        filterType: 'autocomplete',
        type: 'link',
        field: 'project'
      })
    } else {
      columns.push({
        label: 'invoice.list.labelProjectName',
        identifier: 'title',
        width: '12%',
        sort: true,
        filterType: 'autocomplete',
        type: 'link',
        field: 'project'
      })
    }

    columns.push(
      {
        label: 'invoice.list.labelAmountExclVat',
        identifier: 'total',
        width: '17%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'invoice.list.labelAmountInclVat',
        identifier: 'totalInc',
        width: '16%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'invoice.list.labelStatus',
        identifier: 'status',
        width: '10%',
        sort: true,
        filterType: 'autocomplete',
        type: 'status'
      },
      {
        label: 'invoice.list.labelReferencePoNo',
        identifier: 'referenceNo',
        width: '17%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      }
    )

    return columns
  }

  _getSortOptions () {
    return [
      // disabled until we fix the sort function
      // { label: 'invoice.list.labelName', value: 'company' },
      { label: 'invoice.list.labelInvoiceNo', value: 'invoiceNo' },
      { label: 'invoice.list.labelAmountExclVat', value: 'total' },
      { label: 'invoice.list.labelAmountInclVat', value: 'totalInc' },
      { label: 'invoice.list.labelStatus', value: 'status' },
      { label: 'invoice.list.labelReferencePoNo', value: 'referenceNo' },
      { label: 'invoice.list.labelDate', value: 'invoiceDate' }
    ]
  }

  /* Private functions */
  _renderGridOrList () {
    if (this.state.isLoading || !this.data.invoices.length) {
      return null
    }

    let bShowLoader = false
    if (this.data.invoices && this.data.invoices.length < this.data.total) {
      bShowLoader = true
    }

    if (this.data.pageState.type === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.invoices}
            sortOptions={this._getSortOptions()}
            columns={this._getListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onGridItemClick.bind(this)}
            actionIcon='common-action-setting'
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            showLoader={bShowLoader}
            onSettings={this._onGridItemSettingClick.bind(this)}
          />
          {this._renderInvoiceDialog()}
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.invoices}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
        {this._renderInvoiceDialog()}
      </div>
    )
  }

  _renderSettingsDialog () {
    return (
      <DialogSetting
        ref={this._references.invoiceSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
        onEdit={this._onEdit.bind(this)}
        onDelete={this._onDelete.bind(this)}
        downloadUrl={`/invoice/preview/${app.getTeamId()}/${app.loggedInId}`}
        onMarkAsPaid={this._onPaid.bind(this)}
        onCopyInvoice={this._onCopyInvoice.bind(this)}
        onSendMail={this._onSendMail.bind(this)}
        onCreditNote={this._onClickCreditNote.bind(this)}
        isSupportUser={app.isSupportUser()}
      />
    )
  }

  _onCloseSetting () {
    if (this._references.invoiceSettingDialog.current) {
      this._references.invoiceSettingDialog.current.hide()
    }

    this.setState({ bShowDialog: false })
  }

  _onRenderList (invoice, column, idx) {
    const value = invoice[column.identifier]
    const width = column.width
    const showtooltip = invoice[column.showtooltip]
    const estimatedMargin = invoice[column.estimatedMargin]

    if (column.customType === 'price') {
      return (
        <ReportPriceCell
          price={value}
          width={width}
          showtooltip={showtooltip}
          key={idx}
          estimatedMargin={estimatedMargin}
        />
      )
    }

    return ''
  }

  _onRenderGrid (invoice) {
    const pdfFileName = Util.getPdfFileName(
      'invoice',
      invoice.invoiceNo,
      invoice.status
    )
    return (
      <InvoiceItem
        invoice={invoice}
        key={invoice.id}
        showProjectNumber={app.projectSetting.useProjectNo}
        isQuickbookConnected={app.isQuickbookConnected()}
        onView={this._onGridItemClick.bind(this)}
        onSetting={this._onGridItemSettingClick.bind(this)}
        onResendMail={this._onResendMail.bind(this)}
        downloadUrl={`/invoice/preview/${app.getTeamId()}/${app.loggedInId}/${
          invoice.id
        }/false/${pdfFileName}`}
        bShowReminder={!!Acl.isFullUser()}
      />
    )
  }

  _renderMessage () {
    if (!this.state.isLoading && !this.data?.invoices?.length) {
      return (
        <ContentMessage
          message='invoice.list.emptyInvoice'
          info='invoice.list.contentInfo'
          showAddPrefix
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return null
  }

  _onCopyInvoice (invoice) {
    if (invoice) {
      app
        .service('/api/contact')
        .get(invoice.contactId)
        .then(result => {
          if (result) {
            const contactoptions = { label: result.company, value: result.id }
            const copyObj = {
              contactId: invoice.contactId,
              projectId: invoice.projectId,
              id: invoice.id,
              referenceNo: invoice.referenceNo,
              options: contactoptions
            }
            if (this._references.invoiceSettingDialog.current) {
              this._references.invoiceSettingDialog.current.hide()
            }
            if (this._references.refDialogCopyInvoice.current) {
              this._references.refDialogCopyInvoice.current.show(copyObj)
            }
          }
        })
        .catch(err => {
          app.debug('PageInvoice: _onCopyInvoice err', err)
        })
    }
  }

  _onSendMail (invoice) {
    const params = { query: {} }
    app
      .service('/api/invoice/mail')
      .get(invoice.id, params)
      .then(result => {
        this.data.activeInvoice = invoice
        this.setState({ bShowDialog: true, dataDate: new Date() })
        if (result && this._references.refdialogMailSend.current) {
          this._references.refdialogMailSend.current.show(result)
        }
      })
      .catch(err => {
        app.debug('PageInvoiceView: _showEmailDialog err', err)
      })
  }

  _onClickCreditNote (invoice) {
    if (this._references.invoiceSettingDialog.current) {
      this._references.invoiceSettingDialog.current.hide()
    }
    if (invoice.type === 'based-on-actuals') {
      if (this._references.dialogInvoiceCreditActual.current) {
        this._references.dialogInvoiceCreditActual.current.show(invoice)
      }
    } else {
      this._onCreditNote(invoice, false)
    }
  }

  _onSubmitCreditInvoice (invoice, canInvoiceAgain) {
    this._onCreditNote(invoice, canInvoiceAgain)
    if (this._references.dialogInvoiceCreditActual.current) {
      this._references.dialogInvoiceCreditActual.current.hide()
    }
  }

  _onCreditNote (invoice, canInvoiceAgain) {
    if (invoice) {
      const creditObj = {
        parentId: invoice.id,
        canInvoiceAgain: canInvoiceAgain
      }

      app
        .service('/api/invoice/credit')
        .create(creditObj)
        .then(result => {
          if (result) {
            app.changePage('invoice-view', result.id)
          }
        })
        .catch(err => {
          app.debug('PageInvoice: _onCreditNote err', err)
        })
    }
  }

  _onSubmitCopyInvoice (invoiceObj) {
    app
      .service('/api/invoice/copy')
      .create(invoiceObj)
      .then(copyRes => {
        if (copyRes) {
          if (this._references.refDialogCopyInvoice.current) {
            this._references.refDialogCopyInvoice.current.hide()
          }
          app.changePage('invoice-view', copyRes.id)
        }
      })
      .catch(copyErr => {
        app.debug(copyErr)
      })
  }

  _renderInvoiceDialog () {
    return (
      <DialogInvoiceExport
        ref={this._references.invoiceExportDialog}
        noInvoice={this.data.total}
        onExportExcel={this._onClickExport.bind(this, 'xlsx')}
        onExportCsv={this._onClickExport.bind(this, 'csv')}
      />
    )
  }

  _onClickExport (fileType, e) {
    e.preventDefault()
    const data = {
      userId: app.loggedInId,
      fileType: fileType
    }

    const exportParams = {
      query: {
        pageIdent: this._pageIdent,
        pageState: this.data.pageState,
        bUpdatePageState: false,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        invoice: {
          $client: {
            subObjects: {
              contact: ['company', 'image', 'imageUrl'],
              items: []
            }
          }
        }
      }
    }

    app
      .service('/api/invoice/export')
      .create(data, exportParams)
      .then(result => {
        app.redirect(
          `/export/${app.getTeamId()}/invoices/${result.fileType}/${
            result.fileName
          }`
        )
      })
      .catch(err => {
        app.debug('PageInvoice: onClickExport error', err)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.invoiceCreated = this._eventReload.bind(
      this,
      'Invoice',
      'Created'
    )
    this._eventHandlers.invoiceUpdated = this._eventReload.bind(
      this,
      'Invoice',
      'Updated'
    )
    this._eventHandlers.invoiceRemoved = this._eventReload.bind(
      this,
      'Invoice',
      'Removed'
    )
    this._eventHandlers.invoicePatched = this._eventReload.bind(
      this,
      'Invoice',
      'Patched'
    )

    const invoiceService = app.service('/api/invoice')
    invoiceService.on('created', this._eventHandlers.invoiceCreated)
    invoiceService.on('updated', this._eventHandlers.invoiceUpdated)
    invoiceService.on('removed', this._eventHandlers.invoiceRemoved)
    invoiceService.on('patched', this._eventHandlers.invoicePatched)
  }

  _releaseEvents () {
    const invoiceService = app.service('/api/invoice')
    invoiceService.off('created', this._eventHandlers.invoiceCreated)
    invoiceService.off('updated', this._eventHandlers.invoiceUpdated)
    invoiceService.off('removed', this._eventHandlers.invoiceRemoved)
    invoiceService.off('patched', this._eventHandlers.invoicePatched)

    this._eventHandlers.invoiceCreated = null
    this._eventHandlers.invoiceUpdated = null
    this._eventHandlers.invoiceRemoved = null
    this._eventHandlers.invoicePatched = null
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageInvoice - ${objectName} - ${eventName} --`)
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const { stat, pageState } = this.data
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
    lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)
    const filter = this._getNormalizedFilter(pageState.filter)
    const projectSetting = app.projectSetting

    const actions = [
      {
        ident: 'export',
        icon: 'download-solid',
        tooltip: 'contact.list.tipExport',
        tooltipPosition: 'bottom',
        onClick: this._onExport.bind(this)
      }
    ]

    const statInfos = [
      {
        title: 'invoice.view.priceInfo',
        value: stat ? stat.totalUnpaid : 0,
        isPrice: true
      }
    ]

    const filters = [
      {
        ident: 'status',
        type: 'option',
        label: 'invoice.list.filterAll',
        options: [
          { label: 'invoice.list.filterAll', ident: 'all' },
          { label: 'common.list.filterOpen', ident: 'Open' },
          { label: 'invoice.list.filterDraft', ident: 'Draft' },
          { label: 'invoice.list.filterFinal', ident: 'Final' },
          { label: 'invoice.list.filterOverdue', ident: 'Overdue' },
          { label: 'invoice.list.filterPaid', ident: 'Paid' }
        ],
        isMulti: false,
        value: filter.status,
        // TODO: check why defaultValue doesn't set the initial value for the status filter
        defaultValue: 'Open'
      },
      {
        type: 'label',
        label: 'invoice.list.filterInvoices'
      },
      {
        ident: 'project',
        type: 'tag',
        label: 'invoice.list.filterProjects',
        placeholder: 'invoice.list.labelSearchproject',
        isMulti: false,
        value: filter.project || null
      },
      {
        type: 'label',
        label: 'invoice.list.filterFor'
      },
      {
        ident: 'contact',
        type: 'tag',
        label: 'invoice.list.filterClients',
        placeholder: 'invoice.list.labelSearchClient',
        isMulti: false,
        value: filter.contact || null
      },
      {
        type: 'label',
        label: 'invoice.list.filterFor'
      },
      {
        ident: 'datefilter',
        type: 'date',
        label: 'invoice.list.filterAllPeriods',
        isMulti: true,
        value: filter.datefilter || null,
        dateOptions: [
          {
            ident: 'last-week',
            label: 'expense.list.filterDateWeek',
            value: {
              from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
              to: DateUtil.getUTCDateFromTime(
                lastWeekStartDate.getTime() + 1000 * 7 * 24 * 60 * 60
              )
            }
          },
          {
            ident: 'last-month',
            label: 'expense.list.filterDateMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
              to: DateUtil.getUTCDate(currYear, currMonth, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-month',
            label: 'expense.list.filterDateThisMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth, 1),
              to: DateUtil.getUTCDate(currYear, currMonth + 1, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-year',
            label: 'expense.list.filterDateYear',
            value: {
              from: DateUtil.getUTCDate(currYear, 0, 1),
              to: DateUtil.getUTCDate(currYear, 11, 31, 23, 59, 59)
            }
          },
          {
            ident: 'last-year',
            label: 'expense.list.filterDateLastYear',
            subtitle: currYear - 1,
            value: {
              from: DateUtil.getUTCDate(currYear - 1, 0, 1),
              to: DateUtil.getUTCDate(currYear - 1, 11, 31, 23, 59, 59)
            }
          }
        ]
      }
    ]

    const filterActions = [
      {
        ident: 'export',
        icon: 'download',
        tooltip: 'report.view.tipDownloadReport',
        tooltipPosition: 'bottom',
        className: 'filterdownload',
        type: 'invert',
        onClick: this._onExport.bind(this)
      }
    ]

    return (
      <PageHeader
        ref={this._references.refHeaderInvoice}
        title='invoice.list.titleInvoice'
        icon={<InvoicesIcon width={25} />}
        hasFilter
        hasSearch
        showTabs
        activeTab='invoices'
        favoriteTab={this._getUserFavoriteTab('invoice') || 'invoices'}
        tabs={[
          {
            ident: 'invoices',
            title: 'invoicetemplate.list.invoices',
            showFavourite: true
          },
          {
            ident: 'invoice-template',
            title: 'invoicetemplate.list.invoicetemplates',
            showFavourite: true
          }
        ]}
        statInfos={statInfos}
        filters={filters}
        filterActions={filterActions}
        actions={actions}
        showGridList
        isGridActive={pageState.type === 'grid'}
        keywordSearch={filter.keyword}
        placeholderSearch={
          projectSetting.useProjectNo
            ? 'invoice.list.searchPlaceholderWithProjectNumber'
            : 'invoice.list.searchPlaceholder'
        }
        onGridListToggle={this._onHeaderGridListToggle.bind(this)}
        onChange={this._onHeaderChangeFilter.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderGridListToggle (isGridActive) {
    this.data.pageState.type = isGridActive ? 'grid' : 'list'
    this._updatePageState(this.data.pageState)

    this.setState({ dataDate: new Date() })
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = this._getNormalizedFilter(filter)
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'project') {
      this._onCommonFilterProjectSearch(keyword, false, callback)
    } else if (filterIdent === 'contact') {
      this._onCommonFilterContactSearch(keyword, callback)
    }
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('invoice', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - END */
}

export default PageInvoice
